import { createAction } from 'typesafe-actions';

import { SetCurrentLanguagePayload } from './currentLanguage.types';

export const setCurrentLanguage = createAction('SET_CURRENT_LANGUAGE')<SetCurrentLanguagePayload>();
